import React from 'react';
import { Outlet, Route } from 'react-router-dom';
import LazyComponent from '@/components/LazyComponent';

const DashboardPage = React.lazy(() => import('@/pages/admin/Dashboard'));
const AdminCoursePage = React.lazy(() => import('@/pages/admin/Course'));
const AdminCourseDetailPage = React.lazy(
  () => import('@/pages/admin/Course/Detail')
);
const UsersPage = React.lazy(() => import('@/pages/admin/Users'));
const SettingsPage = React.lazy(() => import('@/pages/admin/Settings'));
const MessagesPage = React.lazy(() => import('@/pages/admin/Messages'));

function Index() {
  return (
    <Route path='admin' element={<Outlet />}>
      <Route index element={<LazyComponent AsyncComponent={DashboardPage} />} />
      <Route
        path='users'
        element={<LazyComponent AsyncComponent={UsersPage} />}
      />
      <Route
        path='new-users'
        element={<LazyComponent AsyncComponent={UsersPage} />}
      />
      <Route
        path='messages'
        element={<LazyComponent AsyncComponent={MessagesPage} />}
      />
      <Route
        path='course/detail'
        element={<LazyComponent AsyncComponent={AdminCourseDetailPage} />}
      />
      <Route
        path='course'
        element={<LazyComponent AsyncComponent={AdminCoursePage} />}
      />
      <Route
        path='settings'
        element={<LazyComponent AsyncComponent={SettingsPage} />}
      />
    </Route>
  );
}

export default Index;
